module.exports = __webpack_public_path__ + "img/base_activites_rando_demi_journee.70108434.svg";